import React from "react";
import { QRCodeCanvas } from "qrcode.react";

const CheckInQRCode = () => {
  const checkInUrl = "P0HICTGX-D0TW7OTQ-49IW6QTE/ID907EHJ-ESQE4T3R-SWLXV8KO"; //entityId/profileID
  const POCUrl = "/check_in/O9QT0SM6-GI7HFPA6-JFBDA7S7"; // poc location qr

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      Profile QR
      <QRCodeCanvas value={checkInUrl} size={200} />
      <span className="mt-8">
        POC QR
        <QRCodeCanvas value={POCUrl} size={200} />
      </span>
    </div>
  );
};

export default CheckInQRCode;
